import { ErrorHandler, inject, Injectable, Injector } from '@angular/core';
import { GlobalErrorHandler } from '@eps/ui-components';
import {
  FeedbackDiagnosticsService,
  UNHANDLED_ERROR,
  UNHANDLED_REJECTION,
} from '../../shared/services/feedback-diagnostics.service';

const isRejection = (error: unknown): boolean =>
  (typeof PromiseRejectionEvent !== 'undefined' && error instanceof PromiseRejectionEvent) ||
  (typeof error === 'object' && error !== null && 'rejection' in error && 'promise' in error);

/**
 * Records a categorized code for every unhandled error, then hands the error to the existing
 * `GlobalErrorHandler` unchanged. The error itself, its message and stack are never recorded.
 */
@Injectable()
export class FeedbackErrorHandler implements ErrorHandler {
  private readonly _delegate = inject(GlobalErrorHandler);
  private readonly _injector = inject(Injector);

  handleError(error: unknown): void {
    try {
      // Resolved lazily: the error handler is created before most of the application.
      this._injector
        .get(FeedbackDiagnosticsService)
        .recordApplicationError(isRejection(error) ? UNHANDLED_REJECTION : UNHANDLED_ERROR);
    } catch {
      // Diagnostics must never change how errors are reported.
    }
    this._delegate.handleError(error as Error);
  }
}
